var _y, _d;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { SelectKind as s } from "./index.es135.js";
import e from "./index.es501.js";
var l = {
  styles: e.outlineKind,
  valuedStyles: e.outlineValued,
  errorStyles: e.outlineError,
  disabledStyles: e.outlineDisabled
},
    t = {
  styles: e.ghostyKind,
  valuedStyles: "",
  errorStyles: e.ghostyError,
  disabledStyles: e.ghostyDisabled
},
    o = {
  styles: e.simpleKind,
  valuedStyles: e.simpleValued,
  errorStyles: e.simpleError,
  disabledStyles: e.simpleDisabled
},
    y = (_y = {}, _defineProperty(_y, s.outline, l), _defineProperty(_y, s.ghosty, t), _defineProperty(_y, s.simple, o), _y),
    d = (_d = {}, _defineProperty(_d, s.outline, ""), _defineProperty(_d, s.ghosty, e.buttonGhosty), _defineProperty(_d, s.simple, ""), _d);
export { d as ColorSchemeButtonStylesMap, y as ColorSchemeStylesMap };